import React, { Component } from 'react';
import { Sparklines, SparklinesLine, SparklinesSpots } from 'react-sparklines';

class SparkLine extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.value || []
        }
    }
    render() {
        const { data } = this.state;
        
        return (
            <React.Fragment>
                {/* <Sparklines data={[5, 10, 5, 20, 8, 15]} limit={5} width={100} height={20} margin={5}>
                </Sparklines> */}
                <Sparklines data={data} width={100} height={40} >
                    <SparklinesLine style={{ stroke: "rgba(2, 164, 153,0.8)", fill: "rgba(2, 164, 153,0.8)" }} />
                    <SparklinesSpots style={{ fill: "rgba(2, 164, 153,0.3)" }} />
                </Sparklines>
            </React.Fragment>
        );
    }
}

export default SparkLine;